import { api } from './networkService';

class AuthService {
    static async login(credentials, lang) {
        try {
            const response = await api.post(`api/user/auth/login/${lang}`, credentials);
            return response.data;
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        }
    }

    static async logout(body) {
        try {
            const response = await api.post('api/user/auth/logout', body);
            return response;
        } catch (error) {
            console.error('Logout error:', error);
            throw error;
        }
    }

    static async changeLanguage(body) {
        try {
            const response = await api.post('api/user/auth/change-language', body);
            return response;
        } catch (error) {
            console.error('Change language error:', error);
            throw error;
        }
    }
}

export default AuthService;
